module.exports = __webpack_public_path__ + "static/img/banner1.17b99d77.png";